import {
  TireSearchFormValues,
  TireEditFormValues,
  TireDetailFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
   SETTING - TIRE SEARCH
---------------------------------------------------------------------------------------------*/
export const initialTireSearchForm: TireSearchFormValues = {
  search: "",
};

/*-------------------------------------------------------------------------------------------
   SETTING - TIRE DETAIL
---------------------------------------------------------------------------------------------*/
export const initialTireDetailForm: TireDetailFormValues = {
  id: null,
  width: null,
  height: null,
  radius: null,
  changePrice: null,
  hotelPrice: null,
  manufacturers: [],
};

/*-------------------------------------------------------------------------------------------
     SETTING - TIRE  ROW
---------------------------------------------------------------------------------------------*/

export const initialTireEditForm: TireEditFormValues = {
  width: null,
  height: null,
  radius: null,
  changePrice: null,
  hotelPrice: null,
  manufacturers: [],
};
